import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getservicesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "services", ...action.payload }),
		);
		yield put({
			type: types.GET_SERVICES_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SERVICES_ERROR,
			payload,
		});
	}
}

export function* getservicesWatcherSaga() {
	yield takeLatest(types.GET_SERVICES_START, getservicesHandlerSaga);
}

//delete

function* deleteservicesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("services", action.payload),
		);
		yield put({
			type: types.DELETE_SERVICES_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SERVICES_ERROR,
			payload,
		});
	}
}

export function* deleteservicesWatcherSaga() {
	yield takeLatest(types.DELETE_SERVICES_START, deleteservicesHandlerSaga);
}
